export function formatCurrencyUSD(input) {
  const numericValue = typeof input === "string"
    ? Number(input.replace(/[^0-9.-]+/g, ""))
    : input;

  if (isNaN(numericValue)) return "$0.00";

  return numericValue.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}